<template>
	<!-- <p v-if="showLastTaken">Showing last taken</p> -->
	<div class="last-taken-container">
		<button
			@click="toggleLastTaken(false)"
			class="option last-taken-btn show-hide"
			:class="{
				active: showLastTaken,
				disabled:
					showLastTaken ||
					(!lastTakenPlayer && lastTakenPlayer !== 0),
			}"
		>
			Show last taken
		</button>
		<div
			v-for="(cards, key) in lastTaken"
			:key="key"
			:class="[relativePos(parseInt(key))]"
			class="card-list"
		>
			<transition-group name="fade-last-taken">
				<template v-if="showLastTaken">
					<Card
						class="last-taken"
						v-for="card in cards"
						:key="card.id"
						:suit="card.suit"
						:class="['to-' + relativePos(lastTakenPlayer)]"
						:value="card.value"
						:shown="true"
					/>
				</template>
			</transition-group>
		</div>
	</div>
</template>

<script>
import Card from "./Card";
import { mapGetters } from "vuex";
export default {
	data() {
		return {
			showLastTaken: false,
			timeoutTime: null,
		};
	},
	components: {
		Card,
	},
	emits: ["display-guess-form", "change-guess-form-key"],
	computed: {
		...mapGetters(["lastTaken", "lastTakenPlayer", "me"]),
	},
	methods: {
		relativePos(pos) {
			// How many positions ahead of me?
			let relative = (4 + pos - this.me) % 4;

			// Return appropriate word
			switch (relative) {
				case 0:
					return "bottom";
				case 1:
					return "left";
				case 2:
					return "top";
				case 3:
					return "right";
				default:
					return "";
			}
		},
		toggleLastTaken(renderAgain) {
			if (
				!this.showLastTaken &&
				(this.lastTakenPlayer || this.lastTakenPlayer === 0)
			) {
				// Show last taken
				this.showLastTaken = true;
				this.$emit("display-guess-form", false);

				if (renderAgain) {
					// Changes the key of GuessForm.vue,
					// making it rerender and reset props.
					this.$emit("change-guess-form-key");

					// console.log("FORCING TO CHANGE");
				} else {
					// If no rerender necessary, don't reset.
					// console.log("NO RERENDER NECESSARY.");
				}

				// Reset all timeouts
				if (this.timeoutTime) {
					clearTimeout(this.timeoutTime);
				}

				// Hide last taken after ms
				const ms = 2000;
				this.timeoutTime = setTimeout(() => {
					this.showLastTaken = false;
					this.$emit("display-guess-form", true);
				}, ms);
			}
		},
	},
	watch: {
		lastTaken() {
			this.toggleLastTaken(true);
		},
	},
	created() {
		console.log(">>> LASTTAKEN.VUE");
		console.log(this.showLastTaken);
	},
};
</script>

<style lang="scss" scoped>
$offset: 150px;
$from: 20px;

.card-list {
	position: absolute;
}

.fade-last-taken-enter-from,
.fade-last-taken-leave-to {
	opacity: 0;
}
.top {
	transform: translateY(-$offset);
	.fade-last-taken-enter-from {
		transform: translateY(-$from);
	}
}
.bottom {
	transform: translateY($offset);
	.fade-last-taken-enter-from {
		transform: translateY($from);
	}
}
.left {
	transform: translateX(-$offset);
	.fade-last-taken-enter-from {
		transform: translateX(-$from);
	}
}
.right {
	transform: translateX($offset);
	.fade-last-taken-enter-from {
		transform: translateX($from);
	}
}

.fade-last-taken-leave-to {
	&.to-bottom {
		transform: translateY($from);
	}
	&.to-top {
		transform: translateY(-$from);
	}
	&.to-right {
		transform: translateX($from);
	}
	&.to-left {
		transform: translateX(-$from);
	}
}

.fade-last-taken-enter-active,
.fade-last-taken-leave-active {
	transition: all 0.8s ease;
}

.fade-last-taken-enter-active {
	transition-delay: 0.1s;
}

$option-grey: rgb(105, 110, 122);

button.option.last-taken-btn {
	position: absolute;
	right: 20px;
	bottom: 20px;

	width: 120px;
	z-index: 100;
	color: white;
	margin: 0 4px;
	padding: 4px 8px;
	cursor: pointer;
	transition: 0.2s;
	&:hover {
		background-color: lighten($option-grey, 2%);
	}
	background-color: $option-grey;
	&.disabled {
		color: #999;
		cursor: not-allowed;
		background-color: darken($option-grey, 10%);
	}
}
.show-hide {
	box-shadow: 0px 3px rgba(0, 0, 0, 0.3);
	border-radius: 3px;
	&.active {
		box-shadow: 0px -2px rgba(0, 0, 0, 0.2);
		transform: translateY(1px);
		background-color: darken($option-grey, 10%);
	}
}
</style>
